module.exports = __webpack_public_path__ + "img/DS-tab.96acf56d.jpg";